import { useState, useCallback } from 'react'
import { api } from '../services/api'

export function useApi() {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const call = useCallback(async (method, path, body) => {
    setLoading(true)
    setError(null)
    try {
      const data = await api[method](path, body)
      return data
    } catch (err) {
      setError(err.message)
      throw err
    } finally {
      setLoading(false)
    }
  }, [])

  return {
    loading,
    error,
    get: (path) => call('get', path),
    post: (path, body) => call('post', path, body),
    put: (path, body) => call('put', path, body),
    del: (path) => call('delete', path),
  }
}
